import React from 'react';
import "./Thankyou.css";
import "../../assets/css/app.css";
import cheked from "../../assets/imgs/cheked.png";

function PrThank() {
  return (
    <div className='proTy'>
    <div className="maxW">
    <h2>Thank You!   <span>For Product Enquiry</span></h2>
          <h6>We will respond you  soon.</h6>
           <div class="proTyimg">
           <img src={cheked} alt="product-img" />
           </div>
          <a href="/">Back to Home</a>
    </div>
  </div>
  )
}

export default PrThank;